import React from 'react';
import AboutHeroSection from './sections/AboutHeroSection';
import AboutDetailsSection from './sections/AboutDetailsSection';

const About = () => {
    return (
        <>
            <AboutHeroSection />
            <AboutDetailsSection />
        </>
    );
};

export default About; 